import { Component, Input, Output, QueryList, ViewChildren, EventEmitter, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HisNavigationService } from '../../core/service/base/his-navigation.service';
import { HisSearchResultTabConfig } from '../model/his-search-result-tab-config';
import { HisSearch } from '../model/search/his-search';
import { HisSearchResultComponent } from './his-search-result.component';
import { HisSessionStorageKeys } from '../../core/model/his-session-storage-keys';
import { HisGlobalDataService } from '../../core/service/base/his-global-data.service';
import { HisSearchParserHelper } from '../model/search/his-search-parser-helper';
import { catchError } from 'rxjs';
import { HisSearchService } from '../service/his-search.service';

@Component({
    selector: 'his-multi-search-result',
    templateUrl: './his-multi-search-result.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HisMultiSearchResultComponent {
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private globalDataService = inject(HisGlobalDataService);
    private searchService = inject(HisSearchService);

    @Input() set tabs(tabs: HisSearchResultTabConfig[]) {
        if (tabs?.length) {
            const lastResultConfigFiles = sessionStorage.getItem(HisSessionStorageKeys.CS_SYS_LAST_RESULT_CONFIG_FILES);
		    if (lastResultConfigFiles?.length) {
                this.tabsToDisplay = [];
                tabs.filter(t => lastResultConfigFiles.split(',').includes(t.resultConfigFile)).forEach(t => {
                    this.tabsToDisplay.push(t);
                });
                sessionStorage.removeItem(HisSessionStorageKeys.CS_SYS_LAST_RESULT_CONFIG_FILES);
                this.setTabFromQueryParam();
		    } else {
                let search = HisSearchParserHelper.convertUrlParamsToHisSearch( this.route.snapshot.queryParams);
                search.configFile = this.searchConfigFile;
                search.allResultConfigFiles = tabs.map(t => t.resultConfigFile);
                this.searchService.validateInputs( search ).pipe().subscribe(
                    ( result: string[] | number ) => {
                        if (Array.isArray(result) && result.length) {
                            this.tabsToDisplay = tabs.filter(t => result.includes(t.resultConfigFile));
                            this.setTabFromQueryParam();
                        }
                    }
                );
            }
        }
    }
    @Input() searchConfigFile!: string;
    @ViewChildren(HisSearchResultComponent) searchResultComponents: QueryList<HisSearchResultComponent>;
    @Output() searchLoaded = new EventEmitter<HisSearch>();

    selectedTabIndex = -1;
    loadedTabs: number[] = [];

    tabsToDisplay: HisSearchResultTabConfig[] = [];

    getPageTitle() {
        return this.searchResultComponents?.length ? this.searchResultComponents.get(0).pageTitle : '';
    }

    newSearch() {
        if (this.searchResultComponents?.length) {
            this.searchResultComponents.get(0).newSearch();
        }
    }

    changeSearch() {
        if (this.searchResultComponents?.length) {
            this.searchResultComponents.get(0).changeSearch();
        }
    }

    showPrintview() {
        if (this.searchResultComponents?.length) {
            this.searchResultComponents.get(0).showPrintview();
        }
    }

    tabChanged(newTabIndex: any) {
        if (this.selectedTabIndex === newTabIndex) {
            return;
        }
        this.selectedTabIndex = newTabIndex;
        this.loadedTabs.push(newTabIndex);
        this.router.navigate([], {
            queryParams: {
                tabId: this.tabsToDisplay[newTabIndex].idColumn
            },
            queryParamsHandling: 'merge'
        });
    }

    findSearchResultComponentByIdColumn(idColumn: string): HisSearchResultComponent {
        if (this.searchResultComponents?.length && idColumn) {
            let searchResultComponents = this.searchResultComponents.filter(src => src.idColumn === idColumn);
            if (searchResultComponents?.length) {
                return searchResultComponents[0];
            }
        }
        return null;
    }

    setTabFromQueryParam() {
        let tabIndex = this.tabsToDisplay.findIndex(t => t.idColumn === this.route.snapshot.queryParamMap.get('tabId'));
        if (tabIndex > -1) {
            this.tabChanged(tabIndex);
        } else {
            this.tabChanged(0);
        }
    }
}
